(() => {
  const initialize = () => {
    const forms = document.querySelectorAll('[data-reseller-form]');

    forms.forEach((form) => {
      if (form.dataset.resellerInitialized === 'true') return;
      form.dataset.resellerInitialized = 'true';

      const host = form.closest('rk-reseller-form');
      const endpoint = host?.dataset.endpoint?.trim();
      const submitButton = form.querySelector('[data-submit-button]');
      const status = form.querySelector('[data-form-status]');
      const initialButtonText = submitButton?.textContent;
      const setStatus = (message, state) => {
        if (!status) return;
        status.textContent = message;
        if (state) {
          status.dataset.state = state;
        } else {
          delete status.dataset.state;
        }
      };

      if (status) status.setAttribute('tabindex', '-1');

      form.addEventListener('submit', async (event) => {
        if (!endpoint) return;

        form.querySelectorAll('[data-reseller-invalid="true"]').forEach((field) => {
          field.removeAttribute('aria-invalid');
          delete field.dataset.resellerInvalid;
        });

        event.preventDefault();
        if (form.dataset.submitting === 'true') return;

        if (!form.checkValidity()) {
          form.querySelectorAll(':invalid').forEach((field) => {
            if (field.getAttribute('aria-invalid') !== 'true') {
              field.setAttribute('aria-invalid', 'true');
              field.dataset.resellerInvalid = 'true';
            }
          });
          form.reportValidity();
          return;
        }

        form.dataset.submitting = 'true';
        if (submitButton) submitButton.disabled = true;
        setStatus('Enviando…', 'pending');

        try {
          const params = new URLSearchParams(new FormData(form));
          params.set('source', 'muvon-reseller-form');
          params.set('page_url', window.location.href);

          await fetch(endpoint, {
            method: 'POST',
            mode: 'no-cors',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            },
            body: params.toString(),
          });
          form.reset();
          setStatus('Recebemos seus dados. Nossa equipe entrará em contato.', 'success');
          status?.focus();
        } catch {
          setStatus('Não foi possível enviar agora. Tente novamente.', 'error');
          status?.focus();
        } finally {
          delete form.dataset.submitting;
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = initialButtonText;
          }
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
